
































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UserInfo, Menus } from '@/store/pages/login/index.d';
const Login = namespace('login');

@Component
export default class TopNav extends Vue {
  @Login.Getter('userInfo') private userInfo!: UserInfo;
  @Login.Getter('topNav') private topNav!: Menus[];
  @Login.Action('getUserInfo') private getUserInfo: any;
  @Login.Action('logout') private logout: any;
  private activeIndex = '0';

  public mounted() {
    this.getUserInfo();
    this.activeIndex = this.routerExchange(this.$route.path);
  }
  public go(path: any) {
    if (path === '/index/report') {
      sessionStorage.removeItem('start');
      sessionStorage.removeItem('end');
    }
    this.$router.push({path});
  }
  public routerExchange(path: string) {
    return path.split('/').filter((item: string, index: number, arr: string[]) => {
      return index === 0 || index === 1 || index === 2;
    }).join('/');
  }
  public handleCommand(command: any) {
    this.logout().then((res: any) => {
      if (command === 'logout') {
        this.go('/login');
      }
    });
  }
  public jump(path: any) {
    this.activeIndex = this.routerExchange(this.$route.path);
    this.$router.push({path});
  }
  public handleSelect(key: number, keyPath: string) {
    // console.log(key, keyPath)
  }
  public handleOnLogout() {
    // console.log(key, keyPath)
  }
}
